import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BlankLayoutComponent} from './blank-layout/blank-layout.component';
import {RouterModule} from '@angular/router';
import {BasicLayoutComponent} from './basic-layout/basic-layout.component';
import {TranslateModule} from '@ngx-translate/core';
import { TopNavComponent } from './top-nav/top-nav.component';
import { SideNaviComponent } from './side-navi/side-navi.component';
import {SharedModule} from '../../shared.module';
import {NzLayoutModule} from "ng-zorro-antd/layout";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import { NzAffixModule } from 'ng-zorro-antd/affix';
import {NzMenuModule} from "ng-zorro-antd/menu";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzSelectModule} from "ng-zorro-antd/select";
import {NzDropDownModule} from "ng-zorro-antd/dropdown";
import {NzButtonModule} from "ng-zorro-antd/button";
import {FrontCommonToolkitsModule} from "front-common-toolkits";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {NzPopoverModule} from "ng-zorro-antd/popover";
import { NoPermissionLayoutComponent } from './no-permission-layout/no-permission-layout.component';
import {ToolsModule} from "../../components/tools/tools.module";
import {NzAvatarModule} from "ng-zorro-antd/avatar";
import {NzBreadCrumbModule} from "ng-zorro-antd/breadcrumb";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzAlertModule } from 'ng-zorro-antd/alert'
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    SharedModule,
    NzLayoutModule,
    NzToolTipModule,
    NzAffixModule,
    NzMenuModule,
    NzIconModule,
    NzSelectModule,
    NzDropDownModule,
    NzButtonModule,
    FrontCommonToolkitsModule,
    NzDividerModule,
    NzPopoverModule,
    ToolsModule,
    NzAvatarModule,
    NzBreadCrumbModule,
    NgScrollbarModule,
    NzFormModule,
    NzAlertModule,
  ],
    declarations: [BlankLayoutComponent, BasicLayoutComponent, TopNavComponent, SideNaviComponent, NoPermissionLayoutComponent],
    exports: [BlankLayoutComponent, BasicLayoutComponent]
})
export class LayoutModule {
}
